export const CandidaturePaymentType = {
    ADVANCE: 'ADVANCE',
    FINAL: 'FINAL',
    COMPENSATORY: 'COMPENSATORY',

    values: () => {
        return ['ADVANCE', 'FINAL', 'COMPENSATORY'];
    }
}